import { NAME } from './constants';
import { router } from './router';
import { PRReturnPolozky } from './polozky';

export const PRReturn = {
	name: NAME,
	PRReturnPolozky,
	router,
};
